import React, { useEffect, useState, useRef } from "react";
import I18n from "i18n-js";

import { LOCALES } from "../config/locales";

import Dropdown from "./Dropdown";

const LocaleSwitch = ({ locales }) => {

  const [showDropdown, setShowDropdown] = useState(false);
  
  const ref = useRef();

  useEffect(() => {
    const handler = (event) => {
      if (showDropdown && ref.current && !ref.current.contains(event.target)) {
        setShowDropdown(false);
      }
    }

    document.addEventListener("mousedown", handler);
    document.addEventListener("touchstart", handler);

    return () => {
      document.removeEventListener("mousedown", handler);
      document.removeEventListener("touchstart", handler);
    }
  }, [showDropdown]);

  const toggleDropdown = () => {
    setShowDropdown(prev => !prev);
  }

  const selectLocale = (locale) => {
    const url = new URL(window.location);
    url.searchParams.set("locale", locale);
    window.location.href = url.toString();
  }

  const dropdownItems = locales?.map(locale => ({
    title: LOCALES[locale]?.flag,
    onClick: () => selectLocale(locale)
  }));

  return (
    <div className="locale-switch" ref={ref}>
      <button
        className={`action-btn ${showDropdown ? "active" : null}`}
        aria-haspopup="true"
        aria-expanded={showDropdown ? "true" : "false"}
        onClick={toggleDropdown}
      >
        {LOCALES[I18n.locale]?.flag}
      </button>
      <Dropdown
        show={showDropdown}
        submenu={dropdownItems}
      />
    </div>
  );
}

export default LocaleSwitch;
